<div class="FoundReceiptComponent u-border-radius-md u-color-background-primary u-spacing-2xl-pa">
    <div class="FoundReceiptComponent-content">
        <h1 class="u-text-title-md">Charging at {{ receipt()?.site }}</h1>
        <ce-parameter-list class="FoundReceiptComponent-content-parameter-list">
            <ce-parameter-item [orientation]="'horizontal'" [truncated]="true">
                <span ceParameterLabel>Site</span>
                <span ceParameterItemValue>{{ receipt()?.site }}</span>
            </ce-parameter-item>
            <ce-parameter-item [orientation]="'horizontal'" [truncated]="true">
                <span ceParameterLabel>Date</span>
                <span ceParameterItemValue>{{ displayDate() }}</span>
            </ce-parameter-item>
            <ce-parameter-item [orientation]="'horizontal'" [truncated]="true">
                <span ceParameterLabel>Session Started</span>
                <span ceParameterItemValue>{{ displaySessionStarted() }}</span>
            </ce-parameter-item>
            <ce-parameter-item [orientation]="'horizontal'" [truncated]="true">
                <span ceParameterLabel>Duration</span>
                <span ceParameterItemValue>{{ displayDuration() }}</span>
            </ce-parameter-item>
            <ce-parameter-item [orientation]="'horizontal'" [truncated]="true">
                <span ceParameterLabel>Billing Amount</span>
                <span ceParameterItemValue>{{ receipt()?.billedAmount }}</span>
            </ce-parameter-item>
            <ce-parameter-item [orientation]="'horizontal'" [truncated]="true">
                <span ceParameterLabel>Card</span>
                <span ceParameterItemValue>{{ receipt()?.card }}</span>
            </ce-parameter-item>
        </ce-parameter-list>
    </div>

    <div class="FoundReceiptComponent-actions">
        <div class="FoundReceiptComponent-download flex-row flex-center">
            <button
                ce-button
                ce-button-type-tertiary
                class="FoundReceiptComponent-download-button"
                [disabled]="isDownloading()"
                [attr.aria-label]="isDownloading() ? 'Downloading receipt...' : 'Download receipt'"
                (click)="downloadReceipt()"
            >
                @if (isDownloading()) {
                    <ce-spinning-loader />
                } @else {
                    <ng-container suffix-icon>
                        Download receipt
                        <ce-icon [svgIcon]="'download'" />
                    </ng-container>
                }
            </button>
        </div>

        @if (hasSignedMeterValues()) {
            <div class="FoundReceiptComponent-eichrecht">
                <ce-pill ce-pill-tertiary state="success" icon="checkCircleOutline" class="u-spacing-md-mb" size="sm">Eichrecht-signed</ce-pill>
                <button
                    ce-link-button-small
                    ce-link-button-type-secondary
                    class="u-spacing-md-mb"
                    aria-label="Download signed meter values"
                    (click)="downloadXML()"
                >
                    Download signed data (XML)
                    <ce-icon [svgIcon]="'download'" suffix-icon />
                </button>
                <a
                    ce-link-button-small
                    ce-link-button-type-secondary
                    [href]="safeTransparencyUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Verify data at safe-ev.org"
                >
                    Verify data at safe-ev.org
                    <ce-icon [svgIcon]="'new-tab'" suffix-icon />
                </a>
            </div>
        }
    </div>
</div>
